import { Group, UserRole } from 'common/types'

export const filterEndUsers = (group: Group): Group => {
	return {
		...group,
		users: group.users?.filter(user => user.role === UserRole.END_USER) || [],
	}
}
